import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import React from 'react';

let SievePortionPreparationSectionDriedMaterial: React.FC<IWorksheetComponent> = () => (
  <NamePrefixModifier appendNamePrefix="MassMeasurement">
    <ListFieldSection>
      <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" copyTo={['Equipment.Balance']} />
    </ListFieldSection>
    <ListFieldSection heading="Sieve Portion Dry Mass">
      <Field input={<NumericInput />} name="TareMass" />
      <Field input={<NumericInput />} name="TareAndDryMass" />
      <Field input={<TextOutput />} name="DryMass" />
    </ListFieldSection>
  </NamePrefixModifier>
);

SievePortionPreparationSectionDriedMaterial = withInjectedProps(SievePortionPreparationSectionDriedMaterial);

export { SievePortionPreparationSectionDriedMaterial };
export default SievePortionPreparationSectionDriedMaterial;
